import { RootState } from "common";
import { createSelector } from "reselect";

const selectBrandsState = (state: RootState) => state.Brands;

const selectBrands = createSelector(selectBrandsState, (state) => state.brands);

const selectIsLoading = createSelector(
  selectBrandsState,
  (state) => state.isLoading
);

export const selectors = { selectBrands, selectIsLoading };
